import React from "react";
import { useSelector } from "react-redux";
import {
    getPaymentTypeInitialValue,
    UpdateShouldRevertPaymentType,
} from "@qgiv/core-donor";
import { useFormikContext } from "formik";
import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import { selectRegistrationTotals } from "../../../redux/slices/registrationSlice";

const ConnectedUpdateShouldRevertPaymentType = () => {
    const { setValues, values, validateForm } = useFormikContext();
    const { enableAchPayments, enableCCPayments, enablePaypalPayments } =
        useSelector(selectAllFormSettings);
    const { total } = useSelector(selectRegistrationTotals);

    // Get the initial payment type value so that the update component knows
    // what to reset the value to
    const initialPaymentTypeValue = getPaymentTypeInitialValue({
        enableAchPayments,
        enableCCPayments,
        enablePaypalPayments,
    });

    const updateShouldRevertPaymentTypeProps = {
        initialPaymentTypeValue,
        values,
        validateForm,
        setValues,
        totalAmount: total,
    };
    return (
        <UpdateShouldRevertPaymentType
            {...updateShouldRevertPaymentTypeProps}
        />
    );
};

export default ConnectedUpdateShouldRevertPaymentType;
